export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-2xl mx-auto">
        <div className="mb-10 text-center">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-2">联系投稿</h2>
          <p className="text-sm text-foreground-500">有料你就来 — 安全匿名投稿通道</p>
        </div>

        <div className="bg-background-100 rounded-2xl border border-background-200/70 p-6 md:p-8 text-center">
          <div className="w-16 h-16 mx-auto mb-5 rounded-full bg-accent-50 flex items-center justify-center">
            <i className="ri-mail-send-line text-2xl text-accent-500"></i>
          </div>
          <h3 className="text-lg font-semibold text-foreground-800 mb-3">欢迎投稿爆料</h3>
          <p className="text-sm text-foreground-500 leading-relaxed mb-6 max-w-md mx-auto">
            如果你有独家娱乐爆料、反差视频素材或任何圈内消息，欢迎通过以下方式联系我们。所有投稿均支持匿名提交，严格保护爆料人隐私。
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <div className="flex items-center gap-2 px-5 py-3 bg-background-50 rounded-xl border border-background-200/70 cursor-pointer hover:border-primary-200 transition-colors">
              <i className="ri-mail-line text-lg text-primary-500"></i>
              <span className="text-sm text-foreground-700">投稿邮箱</span>
            </div>
            <div className="flex items-center gap-2 px-5 py-3 bg-background-50 rounded-xl border border-background-200/70 cursor-pointer hover:border-primary-200 transition-colors">
              <i className="ri-telegram-line text-lg text-primary-500"></i>
              <span className="text-sm text-foreground-700">私信投稿</span>
            </div>
            <div className="flex items-center gap-2 px-5 py-3 bg-background-50 rounded-xl border border-background-200/70 cursor-pointer hover:border-primary-200 transition-colors">
              <i className="ri-message-2-line text-lg text-primary-500"></i>
              <span className="text-sm text-foreground-700">在线留言</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}